import { AxiosInstance } from "axios";
import { logger } from "@platform/browser-logger";

import {
  UploadDocumentsResponse,
  ProcessDocumentResponse,
  ListProposalDocumentsResponse,
} from "./types";

const AIDOX_BASE_URL = "/ai-dox/v1";
const BP_BASE_URL = "/brokerportal/v1";

export const uploadDocuments = async (
  rfpId: string,
  brokerId: number,
  brokerPortalRfpId: number,
  files: File[],
  axiosInstance: AxiosInstance,
  carrierIdentifier: string,
): Promise<UploadDocumentsResponse> => {
  logger.debug("[PropelX Documents API] Uploading documents:", {
    rfpId,
    brokerId,
    brokerPortalRfpId,
    filesCount: files.length,
    carrierIdentifier,
  });

  const formData = new FormData();
  files.forEach((file) => formData.append("files", file));
  formData.append(
    "payload",
    JSON.stringify({
      brokerId,
      rfpId: brokerPortalRfpId,
      carrierIdentifier,
    }),
  );

  const response = await axiosInstance.post<UploadDocumentsResponse>(
    `${AIDOX_BASE_URL}/rfps/${rfpId}/proposals`,
    formData,
    { headers: { "Content-Type": "multipart/form-data" } },
  );

  logger.debug("[PropelX Documents API] Upload complete:", {
    rfpId,
    uploadedCount: response.data.proposals.length,
  });

  return response.data;
};

export const processDocument = async (
  rfpId: string,
  documentId: string,
  axiosInstance: AxiosInstance,
): Promise<ProcessDocumentResponse> => {
  logger.debug("[PropelX Documents API] Processing document with AI:", {
    rfpId,
    documentId,
  });

  const response = await axiosInstance.post<ProcessDocumentResponse>(
    `${AIDOX_BASE_URL}/rfps/${rfpId}/documents/${documentId}/process`,
  );

  logger.debug("[PropelX Documents API] Process dispatched:", {
    rfpId,
    documentId,
    workflowId: response.data.workflowId,
  });

  return response.data;
};

export const listProposalDocuments = async (
  rfpId: string,
  axiosInstance: AxiosInstance,
): Promise<ListProposalDocumentsResponse> => {
  logger.debug("[PropelX Documents API] Listing proposal documents:", {
    rfpId,
  });

  const response = await axiosInstance.get<ListProposalDocumentsResponse>(
    `${AIDOX_BASE_URL}/rfps/${rfpId}/proposals`,
  );

  logger.debug("[PropelX Documents API] Proposals listed:", {
    rfpId,
    carriersCount: response.data.carriers.length,
  });

  return response.data;
};

export const downloadRfpFile = async (
  downloadLink: string,
  axiosInstance: AxiosInstance,
): Promise<Blob> => {
  logger.debug("[API] Downloading RFP file", { downloadLink });

  const response = await axiosInstance.post<Blob>(
    `${BP_BASE_URL}/getRfpFile`,
    {
      downloadLink,
    },
    { responseType: "blob" },
  );
  return response.data;
};
